export const orbitvuBlock = (): void => {
  /* Handle all individual "Orbitvu block objects" HTML blocks inside the individual "Orbitvu block" HTML block */
  const handleIndividualOrbitvus = (orbitvuBlock: Element) => {
    const orbitvuSingles = orbitvuBlock.querySelectorAll('.js-orbitvuBlock-single')

    /* Individual contents */
    orbitvuSingles.forEach(orbitvuSingle => {
      const orbitvuBlockSwitchers = orbitvuSingle.querySelectorAll('.js-orbitvuBlock-switcherButton')

      /* Individual button */
      orbitvuBlockSwitchers.forEach(orbitvuBlockSwitcher => {
        orbitvuBlockSwitcher.addEventListener('click', () => {
          const rotationfunctionToCall = orbitvuBlock.getAttribute('data-rotation-class')

          if (rotationfunctionToCall && window[rotationfunctionToCall]) {
            window[rotationfunctionToCall]()
          }

          // Timeout due to rotation bug fixing in PHP file
          setTimeout(() => {
            if (orbitvuBlockSwitcher.classList.contains('js-orbitvuBlock-switcherButton-active')) {
              return
            }

            const targetorbitvuBlockKey = orbitvuBlockSwitcher.getAttribute('data-key')
            orbitvuSingles.forEach(orbitvuSingle_sub => {
              const localorbitvuBlockKey = orbitvuSingle_sub.getAttribute('data-key')

              if (targetorbitvuBlockKey === localorbitvuBlockKey) {
                orbitvuSingle_sub.classList.add('-active')
              } else {
                orbitvuSingle_sub.classList.remove('-active')
              }
            })
          }, 100)
        })
      })
    })
  }

  /* Handle all individual "Orbitvu block" HTML blocks on the page */
  const allOrbitvuBlocks = document.querySelectorAll('.js-orbitvuBlock')
  allOrbitvuBlocks.forEach(singleOrbitvuBlock => {
    handleIndividualOrbitvus(singleOrbitvuBlock)
  })
}
